export const parseJSON = (
  jsonString = ''
): ReturnType<typeof JSON.parse> | Record<string, never> => {
  try {
    return JSON.parse(jsonString);
  } catch {
    return {};
  }
};
